const etapasList = [
  {
    codigoEtapaAgregada: 301,
    nomeEtapaAgregada: "Educação Infantil",
    codigoEtapaEnsino: 1,
    nomeEtapaEnsino: "Educação infantil - creche (0 a 3 anos)",
    filtro: "Educação Infantil",
    codigoFiltro: 1,
    nomeEtapaFiltro: "Educação infantil - creche (0 a 3 anos)",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 2,
    nomeEtapaEnsino: "Educação infantil - pré-escola (4 e 5 anos)",
    filtro: null,
    codigoFiltro: 2,
    nomeEtapaFiltro: "Educação infantil - pré-escola (4 e 5 anos)",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 3,
    nomeEtapaEnsino: "Educação infantil - unificada (0 a 5 anos)",
    filtro: null,
    codigoFiltro: 3,
    nomeEtapaFiltro: "Educação infantil - unificada (0 a 5 anos)",
  },
  {
    codigoEtapaAgregada: 302,
    nomeEtapaAgregada: "Ensino Fundamental",
    codigoEtapaEnsino: 14,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 1º Ano",
    filtro: "Ensino Fundamental de 9 anos",
    codigoFiltro: 14,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 1º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 15,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 2º Ano",
    filtro: null,
    codigoFiltro: 15,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 2º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 16,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 3º Ano",
    filtro: null,
    codigoFiltro: 16,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 3º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 17,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 4º Ano",
    filtro: null,
    codigoFiltro: 17,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 4º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 18,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 5º Ano",
    filtro: null,
    codigoFiltro: 18,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 5º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 19,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 6º Ano",
    filtro: null,
    codigoFiltro: 19,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 6º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 20,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 7º Ano",
    filtro: null,
    codigoFiltro: 20,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 7º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 21,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 8º Ano",
    filtro: null,
    codigoFiltro: 21,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 8º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 41,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - 9º Ano",
    filtro: null,
    codigoFiltro: 22,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - multi",
  },
  {
    codigoEtapaAgregada: 303,
    nomeEtapaAgregada: "Multi e correção de fluxo",
    codigoEtapaEnsino: 22,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - multi",
    filtro: null,
    codigoFiltro: 41,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - 9º Ano",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 23,
    nomeEtapaEnsino: "Ensino fundamental de 9 anos - correção de fluxo",
    filtro: null,
    codigoFiltro: 23,
    nomeEtapaFiltro: "Ensino fundamental de 9 anos - correção de fluxo",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 56,
    nomeEtapaEnsino: "Educação infantil e ensino fundamental - multietapa",
    filtro: "Multietapa",
    codigoFiltro: 56,
    nomeEtapaFiltro: "Educação infantil e ensino fundamental - multietapa",
  },
  {
    codigoEtapaAgregada: 304,
    nomeEtapaAgregada: "Ensino Médio",
    codigoEtapaEnsino: 25,
    nomeEtapaEnsino: "Ensino médio - 1ª Série",
    filtro: "Ensino Médio",
    codigoFiltro: 25,
    nomeEtapaFiltro: "Ensino médio - 1ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 26,
    nomeEtapaEnsino: "Ensino médio - 2ª Série",
    filtro: null,
    codigoFiltro: 26,
    nomeEtapaFiltro: "Ensino médio - 2ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 27,
    nomeEtapaEnsino: "Ensino médio - 3ª Série",
    filtro: null,
    codigoFiltro: 27,
    nomeEtapaFiltro: "Ensino médio - 3ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 28,
    nomeEtapaEnsino: "Ensino médio - 4ª Série",
    filtro: null,
    codigoFiltro: 28,
    nomeEtapaFiltro: "Ensino médio - 4ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 29,
    nomeEtapaEnsino: "Ensino médio - não seriada",
    filtro: null,
    codigoFiltro: 29,
    nomeEtapaFiltro: "Ensino médio - não seriada",
  },
  {
    codigoEtapaAgregada: 305,
    nomeEtapaAgregada: "Ensino Médio - Normal/ Magistério",
    codigoEtapaEnsino: 35,
    nomeEtapaEnsino: "Ensino médio - normal/magistério - 1ª Série",
    filtro: "Educação Profissional Técnica de Nível Médio - Integrada",
    codigoFiltro: 30,
    nomeEtapaFiltro:
      "Curso técnico integrado (ensino médio integrado à formação técnica e profissional) 1ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 36,
    nomeEtapaEnsino: "Ensino médio - normal/magistério - 2ª Série",
    filtro: null,
    codigoFiltro: 31,
    nomeEtapaFiltro:
      "Curso técnico integrado (ensino médio integrado à formação técnica e profissional) 2ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 37,
    nomeEtapaEnsino: "Ensino médio - normal/magistério - 3ª Série",
    filtro: null,
    codigoFiltro: 32,
    nomeEtapaFiltro:
      "Curso técnico integrado (ensino médio integrado à formação técnica e profissional) 3ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 38,
    nomeEtapaEnsino: "Ensino médio - normal/magistério - 4ª Série",
    filtro: null,
    codigoFiltro: 33,
    nomeEtapaFiltro:
      "Curso técnico integrado (ensino médio integrado à formação técnica e profissional) 4ª Série",
  },
  {
    codigoEtapaAgregada: 306,
    nomeEtapaAgregada:
      "Educação de Jovens e Adultos (EJA) (ensino fundamental, ensino médio e integrada)",
    codigoEtapaEnsino: 69,
    nomeEtapaEnsino: "EJA - Ensino fundamental - anos iniciais (1º segmento)",
    filtro: null,
    codigoFiltro: 34,
    nomeEtapaFiltro:
      "Curso técnico integrado (ensino médio integrado à formação técnica e profissional) não seriada",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 70,
    nomeEtapaEnsino: "EJA - Ensino fundamental - anos finais (2º segmento)",
    filtro: null,
    codigoFiltro: 74,
    nomeEtapaFiltro:
      "Curso técnico integrado na modalidade EJA (EJA de nível médio integrada à formação técnica e profissional)",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 72,
    nomeEtapaEnsino: "EJA - Ensino fundamental  - anos iniciais e anos finais (EJA Multietapas)",
    filtro: "Ensino Médio - Normal/ Magistério",
    codigoFiltro: 35,
    nomeEtapaFiltro: "Ensino médio - normal/magistério 1ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 71,
    nomeEtapaEnsino: "EJA - Ensino médio (3º segmento)",
    filtro: null,
    codigoFiltro: null,
    nomeEtapaFiltro: null,
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 74,
    nomeEtapaEnsino:
      "Curso técnico integrado na modalidade EJA (EJA integrada à educação profissional de nível médio)",
    filtro: null,
    codigoFiltro: null,
    nomeEtapaFiltro: null,
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 73,
    nomeEtapaEnsino: "Curso FIC integrado na modalidade EJA - nível fundamental",
    filtro: null,
    codigoFiltro: null,
    nomeEtapaFiltro: null,
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 67,
    nomeEtapaEnsino: "Curso FIC integrado na modalidade EJA - nível médio",
    filtro: null,
    codigoFiltro: 36,
    nomeEtapaFiltro: "Ensino médio - normal/magistério 2ª Série",
  },
  {
    codigoEtapaAgregada: 307,
    nomeEtapaAgregada: "Educação Profissional Técnica de Nível Médio - Integrada",
    codigoEtapaEnsino: 30,
    nomeEtapaEnsino: "Curso técnico integrado (ensino médio integrado) - 1ª Série",
    filtro: null,
    codigoFiltro: 37,
    nomeEtapaFiltro: "Ensino médio - normal/magistério 3ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 31,
    nomeEtapaEnsino: "Curso técnico integrado (ensino médio integrado) - 2ª Série",
    filtro: null,
    codigoFiltro: 38,
    nomeEtapaFiltro: "Ensino médio - normal/magistério 4ª Série",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 32,
    nomeEtapaEnsino: "Curso técnico integrado (ensino médio integrado) - 3ª Série",
    filtro: "Educação Profissional Técnica de Nível Médio",
    codigoFiltro: 39,
    nomeEtapaFiltro: "Curso técnico  - concomitante",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 33,
    nomeEtapaEnsino: "Curso técnico integrado (ensino médio integrado) - 4ª Série",
    filtro: null,
    codigoFiltro: 40,
    nomeEtapaFiltro: "Curso técnico  - subsequente",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 34,
    nomeEtapaEnsino: "Curso técnico integrado (ensino médio integrado) - não seriada",
    filtro: null,
    codigoFiltro: 64,
    nomeEtapaFiltro: "Curso técnico misto",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 74,
    nomeEtapaEnsino:
      "Curso técnico integrado na modalidade EJA (EJA integrada à educação profissional de nível médio)",
    filtro: "EJA - Ensino Fundamental",
    codigoFiltro: 69,
    nomeEtapaFiltro: "EJA - ensino fundamental -  anos iniciais",
  },
  {
    codigoEtapaAgregada: 308,
    nomeEtapaAgregada:
      "Educação Profissional  Técnica de Nível Médio - Curso Técnico e FIC - Concomitante ou Subsequente",
    codigoEtapaEnsino: 39,
    nomeEtapaEnsino: "Curso técnico - concomitante",
    filtro: null,
    codigoFiltro: 70,
    nomeEtapaFiltro: "EJA - ensino fundamental -  anos finais",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 40,
    nomeEtapaEnsino: "Curso técnico - subsequente",
    filtro: null,
    codigoFiltro: 72,
    nomeEtapaFiltro: "EJA - ensino fundamental  - anos iniciais e anos finais",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 64,
    nomeEtapaEnsino: "Curso técnico misto",
    filtro: "EJA - Médio",
    codigoFiltro: 71,
    nomeEtapaFiltro: "EJA - ensino médio",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 68,
    nomeEtapaEnsino: "Curso FIC concomitante",
    filtro: null,
    codigoFiltro: null,
    nomeEtapaFiltro: null,
  },
  {
    codigoEtapaAgregada: 309,
    nomeEtapaAgregada: "Formação Inicial e Continuada ou Qualificação Profissional (FIC)",
    codigoEtapaEnsino: 73,
    nomeEtapaEnsino: "Curso FIC integrado na modalidade EJA - nível fundamental",
    filtro: "Formação Continuada ou Qualificação Profissional (FIC)",
    codigoFiltro: 67,
    nomeEtapaFiltro: "Curso FIC integrado na modalidade EJA  - nível médio",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 67,
    nomeEtapaEnsino: "Curso FIC integrado na modalidade EJA - nível médio",
    filtro: null,
    codigoFiltro: 73,
    nomeEtapaFiltro:
      "Curso FIC integrado na modalidade EJA – nível fundamental (EJA integrada à educação profissional de nível fundamental)",
  },
  {
    codigoEtapaAgregada: null,
    nomeEtapaAgregada: null,
    codigoEtapaEnsino: 68,
    nomeEtapaEnsino: "Curso FIC concomitante",
    filtro: null,
    codigoFiltro: 68,
    nomeEtapaFiltro: "Curso FIC concomitante",
  },
];

export default etapasList;
